export const actions = {
  UNLIMITED_SESSION_TIMEOUT: 'UNLIMITED_SESSION_TIMEOUT',
};
